import CurrencyList from 'currency-list'

export const getCurrencyType = (code) => {
    if (!code) return null

    if (CurrencyList.get(code)) {
        return 'FIAT'
    } else {
        return 'CRYPTO'
    }
}